// src/v3/ui/_common/components/ui/markdown.tsx

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface MarkdownProps {
  children: string;
  className?: string;
  compact?: boolean;
}

export function Markdown({ children, className, compact }: MarkdownProps) {
  const content = compact ? children.replace(/\n{3,}/g, "\n\n") : children;
  return (
    <div
      className={`max-w-full break-words text-sm leading-relaxed
        [&_h1]:mb-2 [&_h1]:mt-4 [&_h1]:text-lg [&_h1]:font-bold
        [&_h2]:mb-2 [&_h2]:mt-3 [&_h2]:text-base [&_h2]:font-semibold
        [&_h3]:mb-1 [&_h3]:mt-2 [&_h3]:font-semibold
        ${compact ? "[&_p]:mb-1 [&_p]:mt-0" : "[&_p]:mb-2"}
        ${compact ? "[&_ul]:mb-1 [&_ul]:mt-0" : "[&_ul]:mb-2"} [&_ul]:list-disc [&_ul]:pl-5
        ${compact ? "[&_ol]:mb-1 [&_ol]:mt-0" : "[&_ol]:mb-2"} [&_ol]:list-decimal [&_ol]:pl-5
        [&_li]:mb-1 [&_li]:mt-0
        [&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5 [&_code]:text-xs
        [&_pre]:mb-2 [&_pre]:overflow-x-auto [&_pre]:rounded-md [&_pre]:bg-muted [&_pre]:p-3
        [&_strong]:font-semibold
        [&_blockquote]:border-l-2 [&_blockquote]:border-muted [&_blockquote]:pl-3 [&_blockquote]:italic
        [&_a]:break-all [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2 hover:[&_a]:no-underline
        [&_table]:mb-3 [&_table]:w-full [&_table]:border-collapse [&_table]:text-left
        [&_th]:border [&_th]:border-border [&_th]:bg-muted [&_th]:px-2 [&_th]:py-1.5 [&_th]:text-xs [&_th]:font-semibold
        [&_td]:border [&_td]:border-border [&_td]:px-2 [&_td]:py-1.5 [&_td]:text-xs [&_td]:align-top
        [&_tr:nth-child(even)]:bg-muted/30
        ${className ?? ""}`}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
    </div>
  );
}
